<ng-container [formGroup]="scanRegionFields">
  <td class="scan-region-select">
    <mat-form-field class="inline-editable-editor">
      <mat-select
        class="imaging-request-dropdown-panel"
        formControlName="modality"
        id="modality"
        placeholder="-"
      >
        <mat-option *ngFor="let modality of modalities" [value]="modality">
          {{ modality }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="modality.invalid && (modality.dirty || modality.touched)"
        class="invalid-feedback"
      >
        <div *ngIf="modality.errors?.['required']">
          Please select a Modality.
        </div>
      </mat-error>
    </mat-form-field>
  </td>
  <td class="scan-region-select">
    <mat-form-field class="inline-editable-editor">
      <mat-select
        class="imaging-request-dropdown-panel"
        formControlName="bodyPart"
        id="bodyPart"
        placeholder="-"
      >
        <mat-option *ngFor="let bodyPart of bodyParts" [value]="bodyPart">
          {{ bodyPart }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="bodyPart.invalid && (bodyPart.dirty || bodyPart.touched)"
        class="invalid-feedback"
      >
        <div *ngIf="bodyPart.errors?.['required']">
          Please select a Body Part/Procedure.
        </div>
      </mat-error>
    </mat-form-field>
  </td>
  <td class="scan-region-select">
    <mat-form-field class="inline-editable-editor">
      <mat-select
        class="imaging-request-dropdown-panel"
        formControlName="phaseOfContrast"
        id="phaseOfContrast"
        placeholder="-"
      >
        <mat-option
          *ngFor="let phaseOfContrast of phasesOfContrast"
          [value]="phaseOfContrast"
        >
          {{ phaseOfContrast }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          phaseOfContrast.invalid &&
          (phaseOfContrast.dirty || phaseOfContrast.touched)
        "
        class="invalid-feedback"
      >
        <div *ngIf="phaseOfContrast.errors?.['required']">
          Please select a Phase of Contrast.
        </div>
        <div *ngIf="phaseOfContrast.errors?.['duplicatedStudy']">
          Duplication is not allowed.
        </div>
      </mat-error>
    </mat-form-field>
  </td>
  <td class="actions">
    <mat-icon
      class="delete-scan-region"
      svgIcon="white-cross"
      (click)="delete()"
    ></mat-icon>
  </td>
</ng-container>
